import { useSiteConfig } from 'hooks/useSiteConfig';

export const EmplifiStarsBelowPDPTitle = ({ sku }: { sku: string }) => {
  const { staticFeatures } = useSiteConfig();

  if (!staticFeatures.isPNARegion || !sku) return null;

  return <div id="tt-teaser-widget"></div>;
};
